import { Loader } from 'rsuite';

export const CustomLoader = () => {
  return (
    <div className="flex items-center justify-center min-h-[20vh]">
      <Loader size="md" />
    </div>
  );
};
